import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux';
import { Col, Row } from 'reactstrap';
import PropTypes from 'prop-types';
import Modal from '../../../common/modal/Modal';
import { clearHistoryOfBusMaintenanceStay, getBusMaintenanceStay, getHistoryOfBusMaintenanceStay } from '../../../../actions';
import Table from '../../../common/Table';
import { HISTORY_OF_BUS_MAINTENANCE_STAY_COLUMNS } from '../../../../config/columns';
import { DEFAULT_PAGE_SIZE } from '../../../../config/constants';
import DateCell from '../../../common/cells/DateCell';
import { DATE_TIME_FORMAT } from '../../../../config/locale';
import { tzDiff } from '../../../../utils/date';

const MaintenanceBusFleetHistoryButton = ({
  busMaintenanceStayId,
  currentMaintenanceStay,
  dispatchGetHistoryOfBusMaintenanceStay,
  dispatchClearHistoryOfBusMaintenanceStay,
  histories,
  loadingHistories,
  dispatchGetBusMaintenanceStay
}) => {

  const [show, setShow] = useState(false);

  useEffect(() => () => {
    dispatchClearHistoryOfBusMaintenanceStay();
  }, []);

  const handleOpen = () => {
    setShow(true);
    dispatchGetHistoryOfBusMaintenanceStay(busMaintenanceStayId);
    dispatchGetBusMaintenanceStay({ busMaintenanceStayId });
  }

  const handleClose = () => {
    setShow(false);
    dispatchClearHistoryOfBusMaintenanceStay();
  }

  const calculateNonOperativeTime = () => {
    if (!currentMaintenanceStay) return '—';

    const { noArrivalTime, estimatedArrivalDate, actualDeliveryTime } = currentMaintenanceStay;

    if (noArrivalTime === true || !estimatedArrivalDate) {
      return '—';
    }

    const endDate = actualDeliveryTime || new Date().getTime();

    const totalMinutes = tzDiff({
      startDate: estimatedArrivalDate,
      endDate,
      unit: 'minutes'
    });

    if (totalMinutes < 0) return '—';

    const days = Math.floor(totalMinutes / (24 * 60));
    const hours = Math.floor((totalMinutes % (24 * 60)) / 60);
    const minutes = totalMinutes % 60;

    const parts = [];

    if (days > 0) {
      parts.push(`${days} día${days > 1 ? 's' : ''}`);
      if (hours > 0) parts.push(`${hours}h`);
      if (minutes > 0) parts.push(`${minutes}min`);
    } else if (hours > 0) {
      parts.push(`${hours} hora${hours > 1 ? 's' : ''}`);
      if (minutes > 0) parts.push(`${minutes}min`);
    } else if (minutes > 0) {
      parts.push(`${minutes} minuto${minutes !== 1 ? 's' : ''}`);
    } else {
      const seconds = tzDiff({ startDate: estimatedArrivalDate, endDate, unit: 'seconds' });
      parts.push(`${seconds} segundo${seconds !== 1 ? 's' : ''}`);
    }

    return parts.join(' ');

  };

  const currentDataPanel = currentMaintenanceStay && (
    <div style={{
      backgroundColor: '#f8f9fa',
      padding: '20px',
      borderRadius: '4px',
      marginBottom: '20px',
      border: '1px solid #dee2e6'
    }}>
      <h6>
        Datos Actuales del Mantenimiento
      </h6>
      <Row>
        <Col>
          <div style={{
            fontWeight: '600',
            color: '#495057',
            marginBottom: '5px',
            fontSize: '13px'
          }}>
            Fecha Real de Entrega
          </div>
          <div style={{ color: '#212529' }}>
            {currentMaintenanceStay.actualDeliveryTime ? (
              <strong>
                <DateCell format={DATE_TIME_FORMAT} value={currentMaintenanceStay.actualDeliveryTime} />
              </strong>
            ) : (
              <span style={{ color: '#6c757d', fontStyle: 'italic' }}>
                Aún no entregado
              </span>
            )}
          </div>
        </Col>
        <Col>
          <div style={{
            fontWeight: '600',
            color: '#495057',
            marginBottom: '5px',
            fontSize: '13px'
          }}>
            Tiempo No Operativo
          </div>
          <div style={{
            fontSize: '16px',
            fontWeight: '600',
            color: '#212529'
          }}>
            {calculateNonOperativeTime()}
          </div>
        </Col>
      </Row>
    </div>
  );

  const body = (
    <>
      {currentDataPanel}
      <Table
        columns={HISTORY_OF_BUS_MAINTENANCE_STAY_COLUMNS}
        data={histories}
        loading={loadingHistories}
        noDataMessage="No se encontraron registros de mantenimiento para este bus."
        defaultPageSize={DEFAULT_PAGE_SIZE}
        manual={false}
        filterable
      />
    </>
  )

  return (
    <>
      <Modal
        show={show}
        onClose={handleClose}
        onClickCancel={handleClose}
        body={body}
        title="Historial de Mantenimientos del Bus"
        size="xl"
        onClickClose={handleClose}
      />
      <i
        tabIndex={0}
        role="button"
        className="fa fa-eye text-info mr-3"
        style={{
          cursor: 'pointer',
          width: '36px',
          height: '36px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          borderRadius: '50%',
          border: '1px solid #17a2b8',
          backgroundColor: 'white',
        }}
        title="Ver Historial de Mantenimientos"
        onClick={(e) => {
          e.stopPropagation();
          handleOpen();
        }}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            handleOpen();
          }
        }}
      />
    </>
  )
}

MaintenanceBusFleetHistoryButton.propTypes = {
  busMaintenanceStayId: PropTypes.number.isRequired,
  currentMaintenanceStay: PropTypes.shape({
    actualDeliveryTime: PropTypes.number,
    estimatedArrivalDate: PropTypes.number,
    noArrivalTime: PropTypes.bool,
  }),
  dispatchGetHistoryOfBusMaintenanceStay: PropTypes.func.isRequired,
  dispatchClearHistoryOfBusMaintenanceStay: PropTypes.func.isRequired,
  histories: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  loadingHistories: PropTypes.bool,
  dispatchGetBusMaintenanceStay: PropTypes.func.isRequired,
}

MaintenanceBusFleetHistoryButton.defaultProps = {
  loadingHistories: false,
  currentMaintenanceStay: null,
}

const mapStateToProps = ({ MechanicalMaintenanceUnit }) => ({
  histories: MechanicalMaintenanceUnit.MaintenanceBusFleet.getIn(['historyOfBusMaintenanceStay', 'content']).toJS(),
  loadingHistories: MechanicalMaintenanceUnit.MaintenanceBusFleet.getIn(['historyOfBusMaintenanceStay', 'loading']),
  currentMaintenanceStay: MechanicalMaintenanceUnit.BusMaintenanceStay.getIn(['current', 'content']).toJS(),
})

const mapDispatchToProps = {
  dispatchGetHistoryOfBusMaintenanceStay: getHistoryOfBusMaintenanceStay,
  dispatchClearHistoryOfBusMaintenanceStay: clearHistoryOfBusMaintenanceStay,
  dispatchGetBusMaintenanceStay: getBusMaintenanceStay
}

export default connect(mapStateToProps, mapDispatchToProps)(MaintenanceBusFleetHistoryButton);